import { render, staticRenderFns } from "./download-apk.vue?vue&type=template&id=deb8173a"
import script from "./download-apk.vue?vue&type=script&lang=js"
export * from "./download-apk.vue?vue&type=script&lang=js"
import style0 from "./download-apk.vue?vue&type=style&index=0&id=deb8173a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports